<template>
  <div class="visitor-system">
    <!-- <header class="header">
      <div class="user-info">
        <img class="avatar" src="@/assets/logo.jpg" alt="avatar" />
        <div class="user-details">
          <p class="department">牛津大学附属小学</p>
        </div>
      </div>
    </header> -->
    <div class="background-image">
        <img class="top-image" src="@/assets/di.png" alt="Top Image" />
        <span class="welcome-text">欢迎来到</span>
        <span class="department">{{qiyeName}}</span>
        <span class="dengji">访客系统</span>
      <img class="top-top-image" src="@/assets/image.png" alt="Bottom Image" />
    </div>
    <div class="appointment-container">
      <h3>选择您的预约方式</h3>
      <div class="appointment-method" @click="showModal">
        <img class="iconfont icon-wechat1" src="@/assets/zhuanfa.png" alt="wechat-icon" />
        <span class="iconinfo">微信转发访客自行填写</span>
        <span class="arrow">></span>
      </div>
      <div class="appointment-method"  @click="navigateToForm">
        <img class="iconfont icon-wechat2" src="@/assets/tx.png" alt="wechat-icon" />
        <span class="iconinfo">帮访客直接填写信息</span>
        <span class="arrow">></span>
      </div>
      <div class="appointment-method"  @click="showModal1">
        <img class="iconfont icon-wechat2" src="@/assets/saoma.png" alt="wechat-icon" />
        <span class="iconinfo">访客扫码预约登记</span>
        <span class="arrow">></span>
      </div>
    </div>

    <!-- 模态弹窗 -->
    <div v-if="isModalVisible" class="modal">
      <div class="modal-content">
        <span class="close" @click="closeModal">&times;</span>
        <h3>小程序码</h3>
        <img :src=" qrCodeBase64" alt="小程序码" class="qr-image"/>
        <h4>长按转发到微信</h4>
      </div>
    </div>

    <!-- 模态弹窗 -->
    <div v-if="isModalVisible1" class="modal">
      <div class="modal-content">
        <span class="close" @click="closeModal1">&times;</span>
        <h3>小程序码</h3>
        <img :src=" qrCodeBase641" alt="小程序码" class="qr-image"/>
        <h4>长按转发到微信</h4>
      </div>
    </div>
  </div>
</template>

<script>

import axios from 'axios';
export default {
  name: 'VisitorSystem',
  data() {
    return {
      qiyeName:'',
      isModalVisible: false,
      isModalVisible1: false,
      qrCodeBase64: '', // 用于存储小程序码的Base64编码字符串
      qrCodeBase641: '', // 用于存储小程序码的Base64编码字符串
    };
  },
  methods: {
    handleRedirect() {
        

        // 获取哈希部分
        const hash = window.location.hash;
        // 使用正则表达式提取查询参数
        const matchCode = hash.match(/code=([^&]+)/);
        const matchState = hash.match(/state=([^&]+)/);
        const token = hash.match(/token=([^&]+)/);
        const token1 = token ? token[1] : null;
        // console.log('tokennnnnnnnnnnnnnnnnnnnnnn',token1)
        if(token1){
          localStorage.setItem('token',token1)
          const token2 = localStorage.getItem('token');
              console.log('token', token2);
              this.fetchQiyeName(); // 在 token 获取成功后调用 fetchQiyeName
        }
        
        // 赋值
        this.code = matchCode ? matchCode[1] : null;
        this.state = matchState ? matchState[1] : null;
        // console.log('Code:', this.code);
        // console.log('State:', this.state);
          if (this.code && this.state) {
              // console.log('Code:', this.code);
              // console.log('State:', this.state);

              // 可以在这里发送这些参数到后端
              axios.post('https://fangke.xiao-e.tech/api/redirect ', { code: this.code, state: this.state })
              .then(response => {
                  // console.log('Response:', response.data);
                  // console.log('response.data.data:', response.data.data);
                  //将response.data.data存入cookie中，后续调用其他api要将这个authorization放在头部发送给前端
                  const token = response.data.data;
                  if(token!=null){
                    // 将 token 存储在LocalStorage 中（或者 Vuex store 中）
                  localStorage.setItem('token', token);
                  this.fetchQiyeName(); // 在 token 获取成功后调用 fetchQiyeName
                  }
                  if(token==null){
                    console.log('空的token',localStorage.getItem('token'))
                    this.fetchQiyeName(); // 在 token 获取成功后调用 fetchQiyeName
                  }

                  // const token1 = localStorage.getItem('token');
                  // console.log('token1', token1);
                  
              })
              .catch(error => {
                  console.error('Error:', error);
              });
          } else {
              console.error('Missing code or state parameter');
          }
      },
      // 获得企业名字
    async fetchQiyeName() {
      try {
        const token = localStorage.getItem('token');
        if (token) {
          const response = await this.$axios.get('/api/get_qiye_name', {
            headers: {
              'Authorization': `${token}` // 添加 Authorization 头部
            }
          });
          this.qiyeName = response.data.data; // 假设返回的数据中包含企业名字
          localStorage.setItem('qiyeName', this.qiyeName); // 存储到 localStorage
        } else {
          console.error('No token found in localStorage');
        }
      } catch (error) {
        console.error('Error fetching qiye name:', error);
      } finally {
        this.isLoading = false; // 加载完成
      }
    },
    showModal() {
      this.getMiniProgramCode();
      this.isModalVisible = true;
    },
    showModal1() {
      this.getMiniProgramCode1();
      this.isModalVisible1 = true;
    },
    closeModal() {
      this.isModalVisible = false;
    },
    closeModal1() {
      this.isModalVisible1 = false;
    },
    async getMiniProgramCode() {
      try {
        // 调用后端API获取小程序码的Base64编码字符串
        const response = await this.$axios.get('/api/getXCXQrCode');
        this.qrCodeBase64 = response.data;
      } catch (error) {
        console.error('Error fetching mini program code:', error);
      }
    },
    async getMiniProgramCode1() {
      try {
        // 调用后端API获取小程序码的Base64编码字符串
        const response = await this.$axios.get('/api/getXCXQrCodePhone');
        this.qrCodeBase641 = response.data;
      } catch (error) {
        console.error('Error fetching mini program code:', error);
      }
    },
    navigateToForm() {
      this.$router.push({ name: 'VisitorForm' });
    },


  },
  mounted() {
    this.handleRedirect();
    this.fetchQiyeName();
  }
};
</script>

<style scoped>
.visitor-system {
  display: flex;
  flex-direction: column;
  height: 100vh;
  background-color: #5999fd;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #044d98;
  color: white;
  padding: 20px;
  height: 150px;
}

.user-info {
  display: flex;
  align-items: center;
}

.avatar {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  margin-right: 10px;
}

.user-details {
  display: flex;
  flex-direction: column;
}

.department {
  position: absolute;
  bottom: 200px; /* 距离底部100px */
  left: 20px; /* 距离左侧20px */
  font-size: 30px; /* 设置字体大小 */
  color: #f4cd4e; /* 设置字体颜色 */
  text-align: left; /* 设置文本对齐方式为左对齐 */
  font-weight: bold; /* 设置字体加粗 */
}

.appointment-container {
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  padding: 20px;
  margin-left: 5px;
  margin-top: -150px;
  margin-right: 5px;
  margin-bottom: 150px;
  flex: 1;
  z-index: 10; /* 确保这个值大于图案的 z-index */
}

.appointment-method {
  display: flex;
  align-items: center;
  padding: 10px 20px;
  background-color: #e0f0ff; /* 浅蓝色背景 */
  border-radius: 5px;
  margin-bottom: 15px;
  height: 30px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  cursor: pointer; /* 添加鼠标悬停时的指针样式 */
}

.appointment-method:last-child {
  margin-bottom: 0;
}

.appointment-method span {
  font-size: 14px;
  color: #044da9; /* 图标颜色为蓝色 */
}

.iconfont {
  margin-right: 10px;
}

.icon-wechat1 {
  width: 25px; /* 根据实际logo大小调整 */
  height: 25px; /* 根据实际logo大小调整 */
}

.icon-wechat2 {
  width: 20px; /* 根据实际logo大小调整 */
  height: 20px; /* 根据实际logo大小调整 */
  margin-right: 15px;
}

.arrow {
  color: #007bff;
}

.iconinfo {
  color: #007bff;
  font-weight: bold;
  flex-grow: 1; /* 使文字不居中 */
}

/* 模态弹窗样式 */
.modal {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5); /* 半透明背景 */
  z-index: 20;
}

.modal-content {
  background-color: #fff;
  padding: 20px;
  border-radius: 5px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  text-align: center;
  max-width: 90%; /* 限制模态框的最大宽度 */
}

.close {
  float: right;
  font-size: 24px;
  font-weight: bold;
  cursor: pointer;
}

.close:hover {
  color: red;
}

.qr-image {
  max-width: 100%;
  height: auto;
  display: block; /* 移除默认的内边距 */
  margin: 0 auto; /* 居中显示 */
}

/* 上面的 */
.top-top-image {
  position: absolute;
  bottom: 120px; /* 距离底部25px */
  left: 50%; /* 距离左侧50% */
  width: 182px; 
  height: 189px; 
}
.background-image {
  position: relative;
  width: 100%; /* 图片宽度为100% */
  height: 50vh; /* 图片高度为视口高度的一半 */
  overflow: hidden; /* 隐藏超出部分 */
}

.top-image {
  width: 100%;
  height: 100%;
  object-fit: cover;/* 确保图片覆盖整个区域，同时保持图片的宽高比*/
}
.welcome-text {
  position: absolute;
  bottom: 250px; /* 距离底部150px */
  left: 20px; /* 距离左侧20px */
  color: white; /* 设置字体颜色为白色 */
  font-size: 24px; /* 设置字体大小 */
  font-weight: bold; /* 设置字体加粗 */
  font-style: italic; /* 设置字体为斜体 */
}

.dengji {
  position: absolute;
  bottom: 160px; /* 距离底部100px */
  left: 20px; /* 距离左侧20px */
  font-size: 24px; /* 设置字体大小 */
  color: white; /* 设置字体颜色 */
  text-align: left; /* 设置文本对齐方式为左对齐 */
  font-weight: bold; /* 设置字体加粗 */
}
</style>